import {Routes} from '@angular/router';
import {AddNewStudyComponent} from '@ctms/studies/add-new-study/add-new-study.component';
import {StudyListComponent} from '@ctms/studies/study-list/study-list.component';
import {StudyOverviewComponent} from '@ctms/studies/study-overview/study-overview.component';
import {AddNewSiteComponent} from '@ctms/sites/add-new-site/add-new-site.component';
import {SiteOverviewComponent} from '@ctms/sites/site-overview/site-overview.component';
import {SiteListComponent} from '@ctms/sites/site-list/site-list.component';
import {AddNewParticipantComponent} from '@ctms/participants/add-new-participant/add-new-participant.component';
import {ParticipantOverviewComponent} from '@ctms/participants/participant-overview/participant-overview.component';
import {ParticipantListComponent} from '@ctms/participants/participant-list/participant-list.component';
import {authGuard} from '@shared/services/security/auth.guard';
import {EditsiteComponent} from '@ctms/sites/editsite/editsite.component';
import {EditstudyComponent} from '@ctms/studies/editstudy/editstudy.component';
import {roleGuard} from '@shared/services/security/role-guard';
import {Permissions} from '@models/permissions.enum';
import {typeGuard} from "@shared/services/security/type-guard";
import {PageTypesEnum} from "@shared/services/router/page-types.enum";

export const ctmsRoutes: Routes = [
    {
        path: 'add-new-study',
        component: AddNewStudyComponent,
        canActivate: [authGuard, roleGuard, typeGuard],
        data: {permission: Permissions.ADD_STUDY, type: PageTypesEnum.CTMS}
    },
    {
        path: 'study-overview/:id',
        component: StudyOverviewComponent,
        canActivate: [authGuard, roleGuard, typeGuard],
        data: {permission: Permissions.VIEW_EDIT_STUDY, type: PageTypesEnum.CTMS}
    },
    {
        path: 'study-list',
        component: StudyListComponent,
        canActivate: [authGuard, roleGuard, typeGuard],
        data: {permission: Permissions.LIST_STUDIES, type: PageTypesEnum.CTMS}
    },
    {
        path: 'add-new-site',
        component: AddNewSiteComponent,
        canActivate: [authGuard, roleGuard, typeGuard],
        data: {permission: Permissions.ADD_SITE, type: PageTypesEnum.CTMS}
    },
    {
        path: 'edit-site/:id',
        component: EditsiteComponent,
        canActivate: [authGuard, roleGuard, typeGuard],
        data: {permission: Permissions.EDIT_SITE, type: PageTypesEnum.CTMS}
    },
    {
        path: 'site-overview',
        component: SiteOverviewComponent,
        canActivate: [authGuard, roleGuard, typeGuard],
        data: {permission: Permissions.EDIT_SITE, type: PageTypesEnum.CTMS}
    },

    {
        path: 'site-list',
        component: SiteListComponent,
        canActivate: [authGuard, roleGuard, typeGuard],
        data: {permission: Permissions.LIST_SITES, type: PageTypesEnum.CTMS}
    },
    {
        path: 'add-new-participant',
        component: AddNewParticipantComponent,
        canActivate: [authGuard, roleGuard, typeGuard],
        data: {permission: Permissions.REGISTER_PARTICIPANT, type: PageTypesEnum.CTMS}
    },
    {
        path: 'add-new-participant/:id',
        component: AddNewParticipantComponent,
        canActivate: [authGuard, roleGuard, typeGuard],
        data: {permission: Permissions.EDIT_PARTICIPANT, type: PageTypesEnum.CTMS}
    },
    {
        path: 'participant-overview/:id',
        component: ParticipantOverviewComponent,
        canActivate: [authGuard, roleGuard, typeGuard],
        data: {permission: Permissions.EDIT_PARTICIPANT, type: PageTypesEnum.CTMS}
    },
    {
        path: 'participant-list',
        component: ParticipantListComponent,
        canActivate: [authGuard, roleGuard, typeGuard],
        data: {permission: Permissions.LIST_PARTICIPANTS, type: PageTypesEnum.CTMS}
    },
    {
        path: 'sessions',
        canActivate: [authGuard, roleGuard, typeGuard],
        loadChildren: () => import('@ctms/sessions/sessions.routes')
            .then(routes => routes.routes),
        data: {permission: Permissions.LIST_SESSIONS, type: PageTypesEnum.CTMS}
    },
    {
        path: 'edit-study/:id',
        component: EditstudyComponent,
        canActivate: [authGuard, roleGuard, typeGuard],
        data: {permission: Permissions.VIEW_EDIT_STUDY, type: PageTypesEnum.CTMS}
    },
];
